// React router
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
// Components
import App from "./App";
import UserService from "./services/UserService";
import { getPublicPath } from "./services/PublicUrl";
// Report web vitals
import reportWebVitals from "./reportWebVitals";
// Styles
import "./style.css";
import "./custom.scss";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap/dist/js/bootstrap.bundle.min';
// Axios
import axios from "axios";

const container = document.getElementById("root");
const root = createRoot(container!);

const _axios = axios.create({ baseURL: process.env.REACT_APP_REDIRECTURI });
_axios.interceptors.request.use((config): any => {
  if (UserService.isAuthenticated()) {
    const cb = () => {
      //console.log('axios cb token: ' + UserService.getToken());
      config.headers.Authorization = `Bearer ${UserService.getToken()}`;
      return Promise.resolve(config);
    };
    //console.log('axios update token before cb Authorization Bearer');
    return UserService.updateToken(cb);
  }
}, (error): any => {
  return Promise.reject(error);
});

const renderApp = () => root.render(
  <BrowserRouter basename={getPublicPath() || undefined}>
    <App />
  </BrowserRouter>
);

UserService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
